import React, { useState } from "react";
import { SpinnerRoundFilled } from "spinners-react";

const Feedback = () => {
  const [load, setLoad] = useState(true);
  const loadHandle = () => {
    setLoad(false);
  };

  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700">
          Feedback Form:
        </h1>
        <div className="pt-6">
          <div className="sm:text-lg">
            <div className="container my-10 sm:my-20 sm:px-2">
              <section className="">
                <div className="sm:flex sm:space-x-5">
                  <div className="flex justify-center items-center">
                    {load && (
                      <SpinnerRoundFilled
                        className="sm:-mr-64 sm:mb-24"
                        color="purple"
                        size={50}
                        thickness={100}
                      />
                    )}
                  </div>
                  <div
                    onLoad={loadHandle}
                    className="mb-10 w-full shrink-0 grow-0 basis-auto sm:mb-0 sm:w-6/12 sm:px-3 flex flex-wrap"
                  >
                    {/* eslint-disable-next-line */}
                    <iframe
                      className="w-full h-48 md:h-[550px] rounded-2xl"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d118323.84215064747!2d88.0894171!3d22.064124500000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02f0cb35788045%3A0x58f6d5c69f0de04d!2sHaldia%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1739340478709!5m2!1sen!2sin"
                      style={{ border: "0", marginTop: "2%" }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>

                  <div className="mb-12 w-full shrink-0 grow-0 basis-auto md:mb-0 md:w-6/12 md:px-3 lg:px-6">
                    <h2 className="mb-6 sm:text-2xl font-bold text-center">
                      Please send me your feedback
                    </h2>
                    <form
                      className="bg-slate-200 dark:bg-slate-800 p-5 rounded-2xl"
                      action="https://formspree.io/f/mqkvwkep"
                      method="POST"
                    >
                      <div className="relative mb-3">
                        <div className="">
                          <div className="px-4">
                            <div className="text-lg">Name:</div>
                          </div>
                          <div className="py-2 px-3">
                            <input
                              className="w-full rounded-2xl px-3 py-2 dark:bg-slate-300 dark:placeholder:text-slate-900 dark:text-black"
                              type="text"
                              name="Name"
                              placeholder="Enter your name"
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="relative mb-3">
                        <div className="">
                          <div className="px-4">
                            <div className="text-lg">Email Address:</div>
                          </div>
                          <div className="py-2 px-3">
                            <input
                              className="w-full rounded-2xl px-3 py-2 dark:bg-slate-300 dark:placeholder:text-slate-900 dark:text-black"
                              type="email"
                              name="Email Address"
                              placeholder="Enter your email address"
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="relative mb-3">
                        <div className="">
                          <div className="px-4">
                            <div className="text-lg">Feedback:</div>
                          </div>
                          <div className="py-2 px-3">
                            <textarea
                              rows={5}
                              className="w-full rounded-2xl px-3 py-2 dark:bg-slate-300 dark:placeholder:text-slate-900 dark:text-black"
                              type="text"
                              name="Feedback"
                              placeholder="Write your feedback"
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center">
                        <button
                          type="submit"
                          value="send"
                          className="bg-purple-900 hover:bg-purple-800 text-white text-xl px-3 py-2 rounded-lg w-full mx-3"
                        >
                          Submit Feedback
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
